module.exports = __webpack_public_path__ + "img/hot.471b7d7e.png";